import { View } from 'react-native';
import { ButtonIconChildProps } from './ButtonIconChild.types';
import { mergeStyles } from 'src/_shared/utils/mergeStyles';
import { TBaseButtonChildrenProps } from '../../base-button/BaseButton.types';
import { Icon } from '@photosi/rn-components/icon/Icon';
import { pickPropertyFromMergedStyles } from 'src/_shared/utils/pickPropertyFromMergedStyles';

export const ButtonIconChild = ({
  iconName,
  iconStyle,
  iconDisabledStyle,
  iconFocusStyle,
  iconHoverStyle,
  iconPressedStyle,
  iconTestID,
  disabled,
  focused,
  hovered,
  pressed,
  badgeRenderer,
}: ButtonIconChildProps & TBaseButtonChildrenProps) => {
  if (iconName) {
    let eventIconStyle;
    if (disabled) {
      eventIconStyle = iconDisabledStyle;
    } else if (pressed) {
      eventIconStyle = iconPressedStyle;
    } else if (hovered) {
      eventIconStyle = iconHoverStyle;
    } else if (focused) {
      eventIconStyle = iconFocusStyle;
    }
    const color =
      pickPropertyFromMergedStyles(eventIconStyle, 'color') ?? pickPropertyFromMergedStyles(iconStyle, 'color');

    return (
      <View style={mergeStyles(iconStyle, eventIconStyle)}>
        {badgeRenderer && badgeRenderer}
        <Icon name={iconName} color={color} testID={iconTestID} />
      </View>
    );
  } else {
    return null;
  }
};
